import { Rights } from '@shared/enums';

export interface AccountRights {
  settingsRight: Rights;
  userAdminRight: Rights;
}
